import { ActionTree } from 'vuex';
import { RootState, SingleFilter } from '@/store/types';
import { QuoteState } from './types';
import api from '@/api';
import * as quoteRequests from '@/api/requests/quote/quotes';

export const actions: ActionTree<QuoteState, RootState> = {

    /**
     * Send the quote with email to the customer assigned to the quote.
     *
     * @param quoteId
     */
    async sendToAssignedCustomer({}, quoteId: number) {
        const response = await api.call(quoteRequests.SEND_TO_ASSIGNED_CUSTOMER(quoteId, {}));
    },

    /** Filters */
    
    /**
     * Set filters.
     *
     * @param commit
     * @param dispatch
     * @param filters
     */
    setFilters({ commit }, filters: SingleFilter[]) {
        filters.map((filter) => commit('setFilter', filter));
    },

    /**
     * Reset a single filter.
     *
     * @param commit
     * @param key
     */
    resetFilter({ commit }, key: string) {
        commit('resetFilter', key);
    },
};
